<template>
  <div class="permissions">
    <el-radio-group v-model="group" @change="init" style="margin-bottom: 20px" size="medium">
      <el-radio-button label="0">平台</el-radio-button>
      <el-radio-button label="1">代理商</el-radio-button>
      <el-radio-button label="2">药房</el-radio-button>
    </el-radio-group>
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="90px">
      <el-form-item label="权限名称" label-width="80px">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.userName"
                  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="权限编码">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.code"
                  placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select style="width: 140px" @input="search" v-model="searchForm.title" placeholder="请选择" clearable>
          <el-option label="全部" value=""></el-option>
          <el-option label="启用" value="0"></el-option>
          <el-option label="禁用" value="1"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button type="primary" style="float: right" @click="addPermissionsr">添加权限</el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          row-key="code"
          default-expand-all
          style="width: 100%">
        <el-table-column
            prop="name"
            label="权限名称">
        </el-table-column>
        <el-table-column
            prop="controllerName"
            align="center"
            label="URL配置">
        </el-table-column>
        <el-table-column
            prop="address"
            label="状态">
          <template slot-scope="scope">
            <el-switch
                v-model="!scope.row.isClose"
                @change="deleteFlag(scope.row)"
                :inactive-text="!scope.row.isClose?'禁用':'启用'">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
            prop="address"
            label="备注">
        </el-table-column>
        <el-table-column
            prop="address"
            fixed="right"
            width="150"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="editorClick(scope.row)">编辑</el-button>
<!--            <el-dropdown style="margin-left: 10px" @command="handleCommand($event,scope.row.id)">-->
<!--              <span class="el-dropdown-link">-->
<!--                更多<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--              </span>-->
<!--              <el-dropdown-menu slot="dropdown">-->
<!--                <el-dropdown-item command="a">添加平级权限</el-dropdown-item>-->
<!--                <el-dropdown-item command="b">添加下级权限</el-dropdown-item>-->
<!--              </el-dropdown-menu>-->
<!--            </el-dropdown>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
        :title="titleText"
        :close-on-click-modal="false"
        :visible.sync="permissionsModel"
        width="30%">
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
<!--          <el-form-item label="权限等级">-->
<!--            2-->
<!--          </el-form-item>-->
<!--          <el-form-item label="上级权限">-->
<!--            异常管理-->
<!--          </el-form-item>-->
          <el-form-item label="权限名称" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="权限编号" prop="code">
            <el-input v-model="ruleForm.code" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="父级角色">
            <SelectTree
                style="width: 100%"
                :props="props"
                :options="treeSelectlist"
                :value="ruleForm.parent"
                :clearable="isClearable"
                :accordion="isAccordion"
                @getValue="getValue($event)"
            />
          </el-form-item>
          <el-form-item label="URL">
            <el-input v-model="ruleForm.controllerName" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="ruleForm.note" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-radio-group v-model="ruleForm.pageType">
              <el-radio :label="0">页面</el-radio>
              <el-radio :label="1">窗口</el-radio>
              <el-radio :label="2">页面或窗口</el-radio>
            </el-radio-group>
          </el-form-item>
<!--          <el-form-item label="状态">-->
<!--            <el-radio-group v-model="ruleForm.isClose">-->
<!--              <el-radio :label="true">启用</el-radio>-->
<!--              <el-radio :label="false">禁用</el-radio>-->
<!--            </el-radio-group>-->
<!--          </el-form-item>-->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="permissionsModel = false">取 消</el-button>
    <el-button type="primary"  @click="submitForm('ruleForm')">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import {cloneDeep} from "lodash";
import SelectTree from "@/components/treeSelect.vue";
export default {
  name: "permissions",
  data() {
    return {
      group: '0',
      searchForm: {},
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
      permissionsModel: false,
      ruleForm: {
        isClose:false,
        pageType:0,
        parent:null
      },
      titleText:'新增权限',
      rules: {
        name: [
          {required: true, message: '请输入权限名称', trigger: 'blur'},
        ],
        code: [
          {required: true, message: '请输入权限编号', trigger: 'blur'},
        ],
      },
      tableData: [],
      props: {
        // 配置项（必选）
        value: "code",
        label: "name",
        children: "children"
        // disabled:true
      },
      isClearable: true, // 可清空（可选）
      isAccordion: true, // 可收起（可选）
      // 选项列表（必选）
      treeSelectlist: [],
    }
  },
  components: {
    //someComponent
    Pagination,
    SelectTree
  },
  methods: {
    //添加权限
    addPermissionsr() {
      this.titleText='新增权限'
      this.ruleForm= {
        isClose:false,
        parent:null,
        pageType:0,
      }
      this.permissionsModel=true
    },
    search() {
      this.init()
    },
    clear() {

    },
    //编辑
    editorClick(row) {
      this.titleText='编辑权限'
      this.areaId = row.id
      this.ruleForm = {
        ...row
      }
     this.permissionsModel = true
    },
    //更多操作
    handleCommand(command) {
      this.$message('click on item ' + command);
    },
    deleteFlag(flag) {
      if (!flag.isClose) {
        let data = {
          groupId: this.group,
          code: flag.code
        }
        this.axios
              .delete("api/GroupPrivilege/deletefunction", {params:data}).then((res) => {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        }).finally(error=>{
          this.init()
        })
      } else {
        let data = {
          groupId: this.group,
          privilegeId: flag.code
        }
        this.axios
              .post("api/GroupPrivilege", data).then((res) => {
          this.$message({
            message: '操作成功',
            type: 'success'
          });
        }).finally(error=>{
          this.init()
        })
      }
    },
    // 取值
    getValue(value) {
      this.ruleForm.parent = value;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            ...this.ruleForm,
            isClose:false
          }
          if (this.titleText === '编辑权限') {
            this.axios
                .put("api/Function?id=" + this.areaId, data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.permissionsModel=false
              this.init()
            })
          } else {
            this.axios
                 .post("api/Function", data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.permissionsModel=false
              this.init()
            })
          }
        } else {
          return false;
        }
      });
    },
    // list
    init() {
      let data = {
        groupId: this.group
      }
      this.axios
          .get("api/GroupPrivilege/GetFunctionTree", {params: data})
          .then((res) => {
            this.tableData = res.list
            this.treeSelectlist = cloneDeep(res.list)
          })
    },
  },
  mounted() {
    //
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.permissions {
  .leftBox {
    width: 100px;

    & > div {
      width: 100px;
      height: 80px;
      background: #eeeeee;
      margin: 0 auto;
      text-align: center;
      writing-mode: vertical-lr;
    }
  }
}
</style>